import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTipoPedidoEstabClassifiscService from '@/services/SistemaDKP/SLSTipoPedidoEstabClassifisc.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSTipoPedidoEstabClassifiscService = new SLSTipoPedidoEstabClassifiscService();
  const refTipoPedidoEstabClassifiscListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipopedidoid', label: 'Tipo Pedido', sortable: false },
    { key: 'estabelecimentoid', label: 'Estabelecimento', sortable: true },
    { key: 'classificacaofiscalid', label: 'Classificação Fiscal', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTipoPedidoEstabClassifisc = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('tipopedidoid');
  const isSortDirDesc = ref(false);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refTipoPedidoEstabClassifiscListTable.value ? refTipoPedidoEstabClassifiscListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTipoPedidoEstabClassifisc.value,
    };
  });

  const refetchData = () => {
    if (refTipoPedidoEstabClassifiscListTable.value && typeof refTipoPedidoEstabClassifiscListTable.value.refresh === 'function') {
      refTipoPedidoEstabClassifiscListTable.value.refresh();
    } else {
      console.warn('refTipoPedidoEstabClassifiscListTable não está inicializado ou não possui o método refresh.');
    }
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const create = async (body) => {
    try {
      await sLSTipoPedidoEstabClassifiscService.store(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Classificação Fiscal cadastrada com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      console.error('Erro ao cadastrar Classificação Fiscal.', error);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao cadastrar Classificação Fiscal.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };

  const Updated = async (body) => {
    const response = await sLSTipoPedidoEstabClassifiscService.update(body);
    if (response) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Classificação Fiscal atualizado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Classificação Fiscal não foi atualizada.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
    refetchData();
  };

  const removerData = async (data) => {
    await sLSTipoPedidoEstabClassifiscService.destroy(data);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    tableColumns,
    perPage,
    currentPage,
    totalTipoPedidoEstabClassifisc,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTipoPedidoEstabClassifiscListTable,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    Updated,
    create,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
